import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import { loadApplicationPaymentHistory } from '../../../api/applications';
import cn from './ApplicationPaymentHistory.module.scss';

const paymentHistoryFields = {
  number: { label: 'Number' },
  amount: { label: 'Amount' },
  date: { label: 'Date' },
  description: { label: 'Description' },
};

export function ApplicationPaymentHistory({ applicationId }) {
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true);
        const paymentHistory = await loadApplicationPaymentHistory(applicationId);
        setPaymentHistory(paymentHistory);
      } finally {
        setIsLoading(false);
      }
    };
    loadData();
  }, [applicationId]);

  if (isLoading) {
    return (
      <div className={cn.loader}>
        <CircularProgress />
      </div>
    );
  }

  if (!paymentHistory.length) {
    return (
      <div className={cn.noHistory}>
        No payment history
      </div>
    );
  }

  return (
    <div className={cn.paymentHistoryContainer}>
      <div className={cn.header}>
        {Object.keys(paymentHistoryFields).map(field => (
          <div key={field} className={cn.cell}>{paymentHistoryFields[field].label}</div>
        ))}
      </div>
      <div className={cn.paymentHistory}>
        {paymentHistory.map(payment => (
          <div className={cn.row}>{Object.keys(paymentHistoryFields).map(field => (
            <div className={cn.cell}>{payment[field]}</div>
          ))}
          </div>
        ))}
      </div>
    </div>
  );
}
